/* eslint-disable no-inner-declarations */
import ProductSelector from './components/productselector';
/* eslint-disable-next-line */
import { event, utils, dialogHelper } from '../../Foundation';
import { validation } from '../../Foundation/validation/bte-configurator';
import { buildSummary } from './components/buildsummary';

export class BTEConfigurator {
  /**
   * BTEConfigurator
   * Control a BTE Configurator
   * @param {HTMLElement} element Configurator
   */
  constructor(element) {
    // Name
    element.BTEConfigurator = this;

    // Refs
    this._refs = {
      el: element,
      addToCart: element.querySelector('.btn-primary'),
      selectedProperty: element.querySelector('[data-property]'),
      header: document.querySelector('#header'),
      isHCPConnectTemplate: utils.checkIfNewBTE(),
    };

    // Properites
    this._props = {
      manager: window.Sys.WebForms.PageRequestManager.getInstance(),
    };

    this._onLoad();

    // Updatepanel - callback event attachments
    if (typeof this._props.manager !== 'undefined' && this._props.manager !== null) {
      this._onCallback();
    }

    // Prevent dialog modal to close on esc key
    const dialog = document.querySelector('.configurator_modal');
    const submitButtons = dialog ? [...dialog.querySelectorAll('input[type="submit"]')] : null;
    if (dialog) {
      dialogHelper.preventDialogModalCloseOnEscape(dialog);
      dialogHelper.closeOnSubmit(dialog, submitButtons);
    }
  }

  /**
   * Handler for binding events eg. when page is loading
   */
  _onLoad() {
    // Product selector
    new ProductSelector({
      el: this._refs.el.querySelector('#productselector'),
    });

    // Color picker
    this._colorpicker();

    // Button handling
    this._onConfiguratorSubmit();

    // SelectedProperty: If a user has selected a property from the cart, scroll to that one
    if (this._refs.selectedProperty != null) {
      const offset = this._refs.selectedProperty.offsetTop;
      if (offset) {
        setTimeout(() => {
          window.scrollTo(0, offset);
        }, 1000);
      }
    }
    // Align configurator
    this._alignTopConfigurator();

    // Quantity checker for bundling
    this._checkQuantity();

    if (this._refs.isHCPConnectTemplate) {
      // Validation
      validation();

      // Build Summary
      buildSummary();
    }
  }

  /**
   * Handler for rebinding event eg. after an update has occoured
   */
  _onCallback() {
    /* eslint-disable-next-line */
    this._props.manager.add_endRequest((sender, e) => {
      // Productselector
      new ProductSelector({
        el: this._refs.el.querySelector('#productselector'),
      });

      // Button lock/unlock
      this._onConfiguratorSubmit();

      // Sections
      this._colorpicker();

      // actions
      this._scrollToTarget(sender);

      // Align configurator
      this._alignTopConfigurator();

      // Quantity checker for bundling
      this._checkQuantity();

      if (this._refs.isHCPConnectTemplate) {
        // Validation
        validation();

        // Build Summary
        buildSummary();
      }
    });
  }

  /**
   * Handler for block/unblock of button once submit
   */
  _onConfiguratorSubmit() {
    const oButton = this._refs.el.querySelector('.page-controls .btn-primary');

    if (oButton === null) return false;

    const fnCallback = (e) => {
      if (e.target.classList.contains('is-disabled')) {
        e.preventDefault();
      }

      e.target.classList.add('is-disabled');
    };

    if (oButton) {
      oButton.addEventListener('click', fnCallback.bind(this));
    }
  }

  /**
   * When user selects a color, update related hidden field width value
   */
  _colorpicker() {
    const items = Array.from(this._refs.el.querySelectorAll('.configurator__color-item')),
      itemClickHandler = (e) => {
        if (e.target.className.indexOf('configurator__color-link') > -1) {
          return;
        }

        const item =
            e.target.className.indexOf('configurator__color-item') > -1
              ? e.target
              : e.target.parentElement,
          field = document.getElementById('SelectedColorItemIdHiddenField'),
          label = document.getElementById('SelectedColorItemTextHiddenField'),
          value = item.querySelector('input[type="hidden"]').value;

        // Set selected value
        field.value = value;
        label.value = item.getAttribute('data-color-label');
        this._doPostBackWithValidation('OverviewUpdatePanel', '');
      };

    items.forEach((x) => x.addEventListener('click', itemClickHandler));
    items.forEach((x) =>
      x.addEventListener('keydown', (e) => {
        // Enter key to select color
        if (e.keyCode === 13) {
          itemClickHandler(e);
        }
      }),
    );
  }

  /**
   * Scroll to a predefined area of the page based on feedback
   * @param {Object} panel - Updatepanel
   */
  _scrollToTarget(panel) {
    if (
      panel == null ||
      panel._postBackSettings.panelsToUpdate == null ||
      !panel._postBackSettings.sourceElement.classList.contains('btn-primary')
    ) {
      return false;
    }

    const alerts = Array.from(this._refs.el.querySelectorAll('.configurator__alerts .alert'));
    if (alerts.length) {
      window.scrollTo(0, alerts[0].offsetTop);
    }
  }

  /**
   * Emit and clear postback validation with backend
   * @type {Private}
   */
  _clearPostBackWithValidation() {
    const eventTarget = document.getElementById('__EVENTTARGET'),
      eventArgument = document.getElementById('__EVENTARGUMENT');

    eventTarget.value = eventArgument.value = '';
    Sys.WebForms.PageRequestManager.getInstance().remove_endRequest(clearPostBackWithValidation);
  }

  /**
   * doPostBackWidthValidation
   * @param {String} eventTargetClientId - Client target id
   * @param {String} eventArgument - Argument to parse
   * @type {Private}
   */
  _doPostBackWithValidation(eventTargetClientId, eventArgument) {
    Sys.WebForms.PageRequestManager.getInstance().add_endRequest(clearPostBackWithValidation);
    __doPostBack(eventTargetClientId, eventArgument);
  }

  /**
   * Align top 2 configurator headline to same height
   */
  _alignTopConfigurator() {
    // const headline = this._refs.el.querySelectorAll('.configurator__selector__title');
    // if(!headline) return;
    // utils.alignHeight(headline[0], headline[1]);
  }

  _checkQuantity() {
    // Function is called on pageLoad and pageRefresh
    // If Order Type is Stock or Consignment
    // We need to find all Bundled Product Dropdowns
    // We need to check Quantity
    // If the Quantity is 1 we should only allow 1 item to be selected in the Product Dropdown
    // And disable the other item
    // If the user changes the item back to 'Please Select' then we reenable the other item
    // If the Stock Quantity is > 1 then we dont need to check anything
    // We need to be able to reset the Bundled Product Dropdowns if the Stock Quantity is set back to 1

    // Known Issue
    // Resetting product-dropdown selects as ordertype is changed
    // If a user comes to page and is shown ordertype patient and then picks a left and right receiver
    // And then switches to Stock or Consignment we should reset the product-dropdowns or their picks will still be there when quantity = 1
    // Issue is that on pageLoad the product-dropdowns dont exist as they are injected via js after
    // How do we reset something that doesnt exist?
    // If we addEventListener for DOMNodeInserted then the code will be run multiple times, annoying

    let debugFunction = false;

    let consoleInfo = 'background: #ECBE13; color: #fff; padding: 4px 10px;';
    let consoleParentTrue =
      'background: #77AB59; color: #fff; padding: 4px 10px;border-left:40px solid white;';
    let consoleParentFalse =
      'background: #E35B5D; color: #fff; padding: 4px 10px;border-left:40px solid white;';
    let consoleChildTrue =
      'background: #77AB59; color: #fff; padding: 2px 10px;border-left:80px solid white;';

    if (debugFunction) {
      console.log('%c _checkQuantity ', consoleInfo);
    }

    let orderTypeValue = document.querySelector('[id*="InitialSelectedOrderType"]').value;

    if (orderTypeValue === 'Stock' || orderTypeValue === 'Consignment') {
      if (debugFunction) {
        console.log('%c Order type: ' + orderTypeValue, consoleInfo);
      }

      let quantityField = document.querySelector(
        '#configure__ordertypeandquatiantity .quantity .number-input input',
      )
        ? document.querySelector(
            '#configure__ordertypeandquatiantity .quantity .number-input__field',
          )
        : null;
      if (quantityField) {
        // Find bundled product-dropdowns only
        // We dont need to check other product-dropdowns
        let productDropDownsToCheck = [];
        let findProductDropdowns = document.querySelectorAll('product-dropdown');
        let findProductDropdownsWithSides = [];

        // new
        /* eslint-disable-next-line */
        findProductDropdowns.forEach((productDropdown, i) => {
          if (
            productDropdown.querySelectorAll('.configurator__accessories-content_item').length > 1
          ) {
            findProductDropdownsWithSides = [productDropdown];
          }
        });

        if (debugFunction) {
          console.log('findProductDropdownsWithSides');
          console.log(findProductDropdownsWithSides);
          console.log(findProductDropdownsWithSides.length);
          console.log(typeof findProductDropdownsWithSides);

          console.log('findProductDropdowns');
          console.log(findProductDropdowns);
          console.log(findProductDropdowns.length);
          console.log(typeof findProductDropdowns);
        }

        /* eslint-disable-next-line */
        findProductDropdownsWithSides.forEach((productDropdown, i) => {
          let productDropdownItems = productDropdown.querySelectorAll(
            '.configurator__accessories-content_item',
          );
          let heading = productDropdown.closest('section').querySelector('h2').innerText;
          let productDropdownItemAddButton =
            productDropdown.querySelectorAll('.addAccessoryDropdown');
          if (productDropdownItemAddButton.length > 0) {
            if (debugFunction) {
              console.log('%c' + heading + ' is unbundled', consoleParentFalse);
            }
          } else {
            if (debugFunction) {
              console.log('%c' + heading + ' is bundled', consoleParentTrue);
            }
            productDropDownsToCheck = productDropdownItems;
          }
        });
        if (debugFunction) {
          console.log(
            '%c Product Dropdown items found: ' + productDropDownsToCheck.length,
            consoleParentTrue,
          );
        }
        if (debugFunction) {
          console.log(productDropDownsToCheck);
        }

        // Updated Quantity checker
        let quantityValue = quantityField.value;
        let stockIncrease = quantityField
          .closest('.number-input')
          .querySelector('.number-input__button--plus');
        let stockDecrease = quantityField
          .closest('.number-input')
          .querySelector('.number-input__button--minus');
        if (productDropDownsToCheck.length > 0) {
          stockIncrease.addEventListener('click', () => {
            if (debugFunction) {
              console.log('%c + clicked ', consoleInfo);
            }
            quantityField.addEventListener('change', () => {
              quantityValue = quantityField.value;
              productDropdownSelect();
              resetProductDropdowns();
            });
          });
          stockDecrease.addEventListener('click', () => {
            if (debugFunction) {
              console.log('%c - clicked ', consoleInfo);
            }
            quantityField.addEventListener('change', () => {
              quantityValue = quantityField.value;
              productDropdownSelect();
              resetProductDropdowns();
            });
          });
        }

        // Reset bundled product-dropdowns only
        function resetProductDropdowns() {
          if (debugFunction) {
            console.log('%c resetProductDropdowns Called ', consoleParentTrue);
          }
          if (debugFunction) {
            console.log('%c Current quantity: ' + quantityValue, consoleParentTrue);
          }
          if (quantityValue === '1') {
            if (debugFunction) {
              console.log('%c Reset Product Dropdowns ', consoleChildTrue);
            }
            /* eslint-disable-next-line */
            productDropDownsToCheck.forEach((productDropdown, i) => {
              let firstOption = productDropdown.querySelector('.form-select__list-item > div')
                ? productDropdown.querySelector('.form-select__list-item > div')
                : null;
              if (firstOption) {
                firstOption.click();
              }
            });
          }
        }

        // Clear bundled product-dropdowns only
        function clearProductDropdowns() {
          if (debugFunction) {
            console.log('%c clearProductDropdowns Called ', consoleParentTrue);
          }
          /* eslint-disable-next-line */
          productDropDownsToCheck.forEach((productDropdown, i) => {
            // Mutations
            let target = productDropdown;
            /* eslint-disable-next-line */
            let observer = new MutationObserver(function (mutations) {
              let firstOption = productDropdown.querySelector('.form-select__list-item > div')
                ? productDropdown.querySelector('.form-select__list-item > div')
                : null;
              if (firstOption) {
                firstOption.click();
                observer.disconnect();
              }
            });
            let config = { attributes: true, childList: false, characterData: false };
            observer.observe(target, config);
          });
        }

        // Detect Select Change
        function productDropdownSelect() {
          if (debugFunction) {
            console.log(
              '%c productDropdownSelect Called ',
              consoleParentTrue + 'border-top:40px solid white',
            );
          }
          if (debugFunction) {
            console.log('%c Current quantity: ' + quantityValue, consoleParentTrue);
          }

          /* eslint-disable-next-line */
          productDropDownsToCheck.forEach((productDropdown, i) => {
            // Reset styling
            productDropdown.classList.remove('is-side-selected');
            productDropdown.classList.remove('is-side-not-selectable');
            function checkItem() {
              if (debugFunction) {
                console.log('%c checkItem Called ', consoleParentTrue);
              }
              if (quantityValue === '1') {
                if (debugFunction) {
                  console.log(
                    '%c Allow only one side to be picked because current quantity: ' +
                      quantityValue,
                    consoleChildTrue,
                  );
                }
                let itemSelectIndex =
                  productDropdown.querySelector('select').options[
                    productDropdown.querySelector('select').selectedIndex
                  ].index;
                if (itemSelectIndex === 0) {
                  productDropdown.classList.remove('is-side-selected');
                  let otherSides = productDropdown
                    .closest('product-dropdown')
                    .querySelectorAll(
                      '.configurator__accessories-content_item.is-side-not-selectable',
                    );
                  /* eslint-disable-next-line */
                  otherSides.forEach((otherSide, i) => {
                    otherSide.classList.remove('is-side-not-selectable');
                    otherSide
                      .querySelector('.form-select__placeholder')
                      .setAttribute('tabindex', 0);
                  });
                } else {
                  productDropdown.classList.add('is-side-selected');
                  let otherSides = productDropdown
                    .closest('product-dropdown')
                    .querySelectorAll(
                      '.configurator__accessories-content_item:not(.is-side-selected)',
                    );
                  /* eslint-disable-next-line */
                  otherSides.forEach((otherSide, i) => {
                    otherSide.classList.add('is-side-not-selectable');
                    // Disables keyboard access with tabbing
                    otherSide
                      .querySelector('.form-select__placeholder')
                      .setAttribute('tabindex', -1);
                  });
                }
              } else {
                if (debugFunction) {
                  console.log(
                    '%c More sides to be picked because current quantity: ' + quantityValue,
                    consoleChildTrue,
                  );
                }
              }
            }
            // Interaction
            productDropdown.querySelector('select').addEventListener('change', () => {
              checkItem();
            });
          });
        }

        clearProductDropdowns();
        productDropdownSelect();
      }
    } else {
      if (debugFunction) {
        console.log('%c Order type: ' + orderTypeValue, consoleInfo);
      }
    }
  }
}
